import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * MainGridRowInfoDetailSlot
 */
class MainGridRowInfoDetailSlot extends React.Component {

  render() {
    let newIcon = null;
    if (this.props.isNewIcon) {
      newIcon = (
        <label className="new_icon_detail">
          <span className="new_label">NEW</span>
        </label>
      );
    }

    // メーカー名、タイプ名制御
    const makerName = commonLogic.ellipsisText(this.props.rowData.koumoku16, 16);
    const typeName = commonLogic.ellipsisText(this.props.rowData.koumoku17, 8);

    return (
      <div className="grid_data_info">
        <div className="grid_data_row">
          <span className="grid_data_info_no">No.{this.props.index}</span>
          <span className="grid_data_info_kishu_name_detail">{this.props.rowData.kishumei}</span>
          {newIcon}
        </div>
        <div className="grid_data_row">
          <span className="grid_data_info_maker">{makerName}</span>
          <span className="grid_data_info_type">{typeName}</span>
          <span className="grid_data_info_nohinkaishibi">{commonLogic.toSlashFormatDate(this.props.rowData.nohinkaishibi)}</span>
        </div>
      </div>
    );
  }
}

MainGridRowInfoDetailSlot.propTypes = {
  rowData: PropTypes.any.isRequired,
};

export default MainGridRowInfoDetailSlot;
